module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedThin.1b46393.eot";